export const LEGACY_ENABLE_VEHICLE_HISTORY_UI_FLAG_ID = 'enable_vehicle_history_ui';
export const DISABLE_VEHICLE_HISTORY_UI_FLAG_ID = 'disable_vehicle_history_ui';

export function filterBackofficeCompanyFeatureFlagMetadata<T extends { feature_flag_id: string }>(
  flags: readonly T[],
): T[] {
  return flags.filter((flag) => flag.feature_flag_id !== LEGACY_ENABLE_VEHICLE_HISTORY_UI_FLAG_ID);
}
